import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { FeatureTourStepEnum } from '../../../shared/feature-tour-step.enum';
import { FeatureTourService } from '../../../shared/feature-tour.service';

@Component({
  selector: 'app-step-popover',
  templateUrl: './step-popover.component.html',
  styleUrls: ['./step-popover.component.scss'],
})
export class StepPopoverComponent implements OnDestroy {
  @Input() titleKey: string;
  @Input() descriptionKey: string;
  @Input() nextKey: string;
  @Input() previousKey: string;
  @Output() closeStep: EventEmitter<void> = new EventEmitter();
  @Output() next: EventEmitter<void> = new EventEmitter();
  @Output() previous: EventEmitter<void> = new EventEmitter();

  dismissable = false;
  progression = 0;
  markerPosition: string = null;

  private subscriptions: Subscription = new Subscription();

  constructor(public featureTourService: FeatureTourService) {
    this.subscriptions.add(
      featureTourService.featureTourStepBS.subscribe(value => {
        this.dismissable = [
          FeatureTourStepEnum.SEARCH_BAR,
          FeatureTourStepEnum.ADVANCED_SEARCH,
          FeatureTourStepEnum.MASS_ACTIONS,
        ].includes(value);
        switch (value) {
          case FeatureTourStepEnum.SEARCH_BAR:
            this.progression = 0.334;
            this.markerPosition = 'marker-center';
            break;
          case FeatureTourStepEnum.ADVANCED_SEARCH:
            this.progression = 0.667;
            this.markerPosition = 'marker-right';
            break;
          case FeatureTourStepEnum.MASS_ACTIONS:
            this.progression = 1;
            this.markerPosition = 'marker-right';
            break;

          default:
            this.progression = 0;
            this.markerPosition = null;
            break;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
